import { useVeltClient, VeltComments } from '@veltdev/react';
import React, { useEffect } from 'react'
import './RewriterPage.css';

function RewriterPage() {

    const { client } = useVeltClient();

    useEffect(() => {
        if (!client) return;

        const commentElement = client.getCommentElement();
        commentElement.enableTextComments();

        const rewriterElement = client.getRewriterElement();
        rewriterElement.enableRewriter();

    }, [client]);

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    return (
        <div id="rewriterContainer">
            <VeltComments />
            <p className="boujeeText">Select some text to get rewriter options.</p>
            <article>
                <header>
                    <h1>AI Tools For Writing directly on your website (ChatGPT-4 powered)</h1>
                    <p>Published on March 16, 2023</p>
                </header>
                <div className="content">
                    <p>Pop a bottle with us because we just added a ChatGPT-4 AI-Copilot that is definitely worth the excitement! Superflow empowers you with AI copywriting assistance directly on your website. Goodbye, to the tedious tab-juggling dance.</p>
                    <p>You can provide any prompt to it and it will rewrite the copy for you. You can specify one or all of the following:</p>
                    <ol>
                        <li>Word count/Character limit: "Rewrite to 10 words or fewer"</li>
                        <li>Tone, personality: "Rephrase using Steve Job’s writing style"</li>
                        <li>Target audience: "Rewrite content tailored to US-based coffee enthusiasts aged 20-35"</li>
                    </ol>
                </div>
                <footer>
                    <p>Thanks for reading! If you enjoyed this article, please consider sharing it.</p>
                </footer>
            </article>
        </div>
    )
}

export default RewriterPage;